import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {AuthGuard} from './guard/auth-guard';
import {AppLayoutComponent} from './core/components/app-layout/app-layout.component';
import {LoginComponent} from './core/components/login/login.component';
import {LogoutComponent} from './core/components/logout/logout.component';
import {LoginLayoutComponent} from './core/components/login-layout/login-layout.component';

import {LocaleResolveService} from './core/services/locale-resolve.service';
import {MenuResolveService} from './core/services/menu-resolve.service';

const routes: Routes = [
    {
        path: '',
        component: AppLayoutComponent,
        canActivate: [AuthGuard],
        resolve: { menu: MenuResolveService }, // this returned data will be used from AppLayoutComponent
        children: [
            {path: 'econ-dr', loadChildren: './econ-dr/econ-dr.module#EconDrModule'},
            {path: 'plus-dr', loadChildren: './plus-dr/plus-dr.module#PlusDrModule'},
            {path: 'logout', component: LogoutComponent, data: { title: 'logout' }}
        ]
    },
    {
        path: '',
        component: LoginLayoutComponent,
        children: [
            {path: 'login', component: LoginComponent, resolve: { locale: LocaleResolveService }, data: { title: 'login' }}
        ]
    },
    {path: 'assets', redirectTo: '/assets'},

    // otherwise redirect to home
    {path: '**', redirectTo: ''}
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class OmsRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/oms-routing.module.ts